import { useContext } from 'react';
import { SidebarContext } from '@/contexts/sidebar/SidebarContext';

const useSidebarContext = () => {
  const context = useContext(SidebarContext);

  if (!context) {
    throw new Error(
      'useSidebarContext must be used within an SidebarContextProvider'
    );
  }

  return context;
};

export default useSidebarContext;
